import {Component, inject, Input, OnInit, signal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {KtTripService} from '../service/kt-trip.service';
import {IKtTravelerPaymentDetail} from '../interfaces/kt-trip.interface';

@Component({
  selector: 'app-kt-payment-detail',
  templateUrl: './kt-payment-detail.component.html',
  standalone: false,
})
export class KtPaymentDetailComponent implements OnInit {
  @Input() public data: any;

  private readonly route = inject(ActivatedRoute);
  private readonly tripService = inject(KtTripService);

  protected readonly payment = signal<IKtTravelerPaymentDetail | null>(null);

  public ngOnInit(): void {
    const id = this.data != null ? Number(this.data) : Number(this.route.snapshot.paramMap.get('id'));
    this.tripService.getTravelerPaymentById(id).subscribe(p => this.payment.set(p));
  }
}
